import { render, staticRenderFns } from "./ConfigureSettings.vue?vue&type=template&id=968509d8&scoped=true"
import script from "./ConfigureSettings.vue?vue&type=script&lang=js"
export * from "./ConfigureSettings.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSettings.vue?vue&type=style&index=0&id=968509d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968509d8",
  null
  
)

export default component.exports